import React from 'react';
import { IOfficeViewerProps } from './document-viewer-modal.types';

export const OfficeViewer: React.FC<IOfficeViewerProps> = ({ url, fileName }) => {
  // Use Microsoft Office Web Apps Viewer to display Office documents
  // This viewer works with external storage URLs (unlike Google Docs Viewer)
  const viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;

  return (
    <div className="w-full h-[80vh] flex flex-col">
      <div className="text-xs text-gray-500 mb-2 px-4 pt-2">{fileName}</div>
      <iframe
        src={viewerUrl}
        className="w-full flex-1 border-0"
        title={fileName}
        onError={() => {
          console.error('Failed to load Office document in viewer');
        }}
      />
      <div className="text-xs text-gray-400 text-center py-2 border-t">
        Powered by Microsoft Office Web Apps
      </div>
    </div>
  );
};
